import React, { useState, useEffect } from "react";
import { dimensions } from "../../../utils/helper";

export default function CustomPageTimeline({
  allThumbs,
  store,
  handlePageClick,
  currentActivevPage
}) {
  return (
    <>
      <div className="artboard--main__export--teeshirts lgTimeLineAll">
        {allThumbs.map(({ id, image, isActive, label }, index) => {
          return (
            <div
              onClick={() => handlePageClick(id)}
              key={index}
              className="artboard--main__export--teeshirts--item"
            >
              <div className="artboard--main__export--teeshirts--text">
                {index == "0" ? (
                  <>
                    <h4>
                      <img
                        src={"/assets/images/flag_icn.svg"}
                        alt="Master Layers"
                      />
                      {label}
                    </h4>
                    <h5>{dimensions['M']?.inch}</h5>
                  </>
                ) : (
                  <>
                    <h4>{Object.keys(dimensions)[index - 1]}</h4>
                    <h5>{dimensions[Object.keys(dimensions)[index - 1]]?.inch}</h5>
                  </>
                )}
              </div>
              <div className="artboard--main__export--teeshirts--img">
                <img src={image} />
              </div>
            </div>
          );
        })}
      </div>
    </>
  );

  // return (
  //   <div className="artboard--main__export--teeshirts">
  //     {allThumbs.map(({ id, image, isActive, label }, index) => (
  //       <div
  //         key={id || index}
  //         onClick={() => handlePageClick(id)}
  //         className={`artboard--main__export--teeshirts--item ${
  //           isActive ? "active" : ""
  //         }`}
  //       >
  //         <div className="artboard--main__export--teeshirts--img">
  //           <img src={image} alt={`Thumbnail ${index}`} loading="lazy" />
  //         </div>
  //         <div className="artboard--main__export--teeshirts--text">
  //           <h4>{label}</h4>
  //         </div>
  //       </div>
  //     ))}
  //   </div>
  // );
}

{
  /* <div className="artboard--main__export--teeshirts lgTimeLineAll">
{allThumbs?.length > 0 &&
  allThumbs?.map((image, index) => {
    console.log('index is',index)
    const pageList = store.pages;
    return (
      <div
        onClick={() => store.selectPage(store.selectPage[index]?.id)}
        key={index}
        className="artboard--main__export--teeshirts--item"
      >
        <div className="artboard--main__export--teeshirts--text">
            {index == "0" ? (
              <>
                <h4>
                  <img
                    src={"/assets/images/flag_icn.svg"}
                    alt="Master Layers"
                  />
                  Master
                </h4>
                <h5>12.5 X 19 in</h5>
              </>
            ) : (
              <>
                <h4>{Object.keys(dimensions)[index - 1]}</h4>
                <h5>12.5 X 19 in</h5>
              </>
            )}
        </div>
        <div className="artboard--main__export--teeshirts--img">
          <img src={image} />
        </div>
      </div>
    );
  })}
</div> */
}
